import React, { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import AsyncSelect from "react-select/async";
import UsersApi from "../../../../../Classes/API/UsersApi";
import searchUsersReq from "../../../../../Classes/Models/Requests/Users/SearchUser";
import UserTypes from "../../../../../Classes/Models/Requests/Users/UserTypes";
import Icon from "@mui/material/Icon";

const SearchSingleSessions = ({ setSearchReq, GetTableData }) => {
  const [filterState, setFilterState] = useState({
    patientId: null,
    sessionId: "",
    sessionName: "",
    isPaidFor: false,
    isException: false,
    noAppointmentOnly: true,
  });

  const [PatientsSearch, setPatientsSearch] = useState("");

  useEffect(() => {
    setSearchReq((prev) => ({
      ...prev,
      ...filterState,
      pagingParams: { ...prev.pagingParams, pageNumber: 1 },
    }));
  }, [filterState, setSearchReq]);

  const GetPatients = async () => {
    let searchReq = new searchUsersReq();
    searchReq.name = PatientsSearch;
    searchReq.userType = new UserTypes().Patient;
    let res = await UsersApi.SearchUsers(searchReq);
    if (res.status === "Success") {
      return res.data.list.map((item) => ({
        value: item.getPatient,
        label: item.name,
      }));
    }
    return [];
  };

  return (
    <MDBox
      p={3}
      sx={{
        backgroundColor: "#fff",
        borderRadius: "12px",
        border: "1px solid #ebedef",
        boxShadow: "0 2px 12px 0 rgba(0,0,0,0.05)",
        mb: 3,
      }}
    >
      <div className="row g-3 align-items-start">
        <div className="col-md-4">
          <AsyncSelect
            placeholder="Search Patient..."
            isClearable
            loadOptions={GetPatients}
            onInputChange={setPatientsSearch}
            onChange={(e) =>
              setFilterState((p) => ({
                ...p,
                patientId: e ? e.value.id : null,
              }))
            }
            styles={{
              control: (base) => ({
                ...base,
                minHeight: "42px",
                borderRadius: "4px",
                borderColor: "#d2d6da",
                fontSize: "0.8rem", 
              }),            
            }}
          />
        </div>
        <div className="col-md-3">
          <MDInput
            fullWidth
            label="Session Name"
            value={filterState.sessionName}
            onChange={(e) =>
              setFilterState((p) => ({ ...p, sessionName: e.target.value }))
            }
            sx={{ "& .MuiInputBase-root": { height: "44px" } }}
          />
        </div>
        <div className="col-md-2">
          <MDInput
            fullWidth
            label="ID"
            value={filterState.sessionId}
            onChange={(e) =>
              setFilterState((p) => ({ ...p, sessionId: e.target.value }))
            }
            sx={{ "& .MuiInputBase-root": { height: "44px" } }}
          />
        </div>
        <div className="col-md-3">
          <MDButton
            variant="gradient"
            color="info"
            fullWidth
            circular
            onClick={GetTableData}
            sx={{ height: "44px" }}
          >
            <Icon sx={{ fontWeight: "bold" }}>search</Icon>
            &nbsp; Search
          </MDButton>
        </div>

        <div className="col-12">
          <MDBox display="flex" gap={4} mt={1} ml={1}>
            <label style={checkboxLabelStyle}>
              <input
                type="checkbox"
                style={checkboxInputStyle}
                checked={filterState.isPaidFor}
                onChange={() =>
                  setFilterState((p) => ({ ...p, isPaidFor: !p.isPaidFor }))
                }
              />
              Paid For
            </label>
            <label style={checkboxLabelStyle}>
              <input
                type="checkbox"
                style={checkboxInputStyle}
                checked={filterState.isException}
                onChange={() =>
                  setFilterState((p) => ({ ...p, isException: !p.isException }))
                }
              />
              Exception
            </label>
            <label style={checkboxLabelStyle}>
              <input
                type="checkbox"
                style={checkboxInputStyle}
                checked={filterState.noAppointmentOnly}
                onChange={() =>
                  setFilterState((p) => ({
                    ...p,
                    noAppointmentOnly: !p.noAppointmentOnly,
                  }))
                }
              />
              No Appointments
            </label>
          </MDBox>
        </div>
      </div>
    </MDBox>
  );
};

const checkboxLabelStyle = {
  fontSize: "0.875rem",
  color: "#7b809a",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  fontWeight: "400",
};

const checkboxInputStyle = {
  marginRight: "8px",
  width: "16px",
  height: "16px",
  cursor: "pointer",
  accentColor: "#1A73E8",
};

export default SearchSingleSessions;
